import { ModalOpenButton } from "@msys/ui";
import { Button, ButtonProps } from "@mui/material";
import { CrmCompanyInviteModal } from "../modals/CrmCompanyInviteModal.js";

interface Props {
  crmCompanyId: string;
  refetchQueries: string[];
  label: string;
  size?: ButtonProps["size"];
}

export function CrmCompanyInviteButton({
  crmCompanyId,
  refetchQueries,
  label,
  size,
}: Props) {
  return (
    <ModalOpenButton
      Modal={CrmCompanyInviteModal}
      modalProps={{ crmCompanyId, refetchQueries }}
    >
      <Button
        size={size}
        variant="outlined"
        color="primary"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {label}
      </Button>
    </ModalOpenButton>
  );
}
